import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { BsGraphUp } from "react-icons/bs";
import { IoSettingsSharp } from "react-icons/io5";
import { IoLogOutOutline } from "react-icons/io5";
import { CgProfile } from "react-icons/cg";
import { HiOutlineSwatch } from "react-icons/hi2";
import { CiSettings } from "react-icons/ci";
import { FaBars, FaTimes } from "react-icons/fa";
import { LuChevronDown } from "react-icons/lu";
import { useLocation } from "react-router-dom";
import { MdAccountBalance } from "react-icons/md";
import {
  TbWorldSearch,
  TbChartHistogram,
  TbNews,
  TbActivityHeartbeat,
  TbChartLine,
  TbGridDots,
  TbArrowsExchange,
  bChartInfographic,
  TbTargetArrow,
  TbStack2,
  TbChartCandle,
  TbBuildingBank,
  TbBinaryTree2,
} from "react-icons/tb";

import { LuCircleHelp } from "react-icons/lu";
import { LuLayoutDashboard } from "react-icons/lu";

import {
  FiStar,
  FiMessageCircle,
  FiHelpCircle,
  FiUser,
  FiSearch,
} from "react-icons/fi";

import { TbLayoutDashboard } from "react-icons/tb";

import { CiSearch } from "react-icons/ci";
import { TbFilterSearch } from "react-icons/tb";
import axios from "axios";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { useMarketToggle } from "../../context/MarketContext";
import { useStock } from "../../context/StockContext";
import { useIndicators } from "../../context/IndicatorContext";
import { useAuth } from "../../context/AuthNewContext";
import { useSearchStock } from "../../context/SearchStockContext";
import useGlobalSearch from "../../hooks/useGlobalSearch";
import logo from "../../assets/phronesis-logo.webp";
import qkLogo from "../../assets/qk_logo.png";
import "./Navbar.css";
import MobileSubNavbar from "../SubNavbar/SubNavbar";
import SubNavbar from "../SubNavbar/SubNavbar";

const Navbar = () => {
  // const [search, setSearch] = useState("");  //commneted for new search context
  const [nseCode, setNseCode] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchSymbol, setSearchSymbol] = useState("");
  // const [results, setResults] = useState([]); //commneted for new search context
  const { user, logout } = useAuth();
  const [selectedTab, setSelectedTab] = useState("");
  const location = useLocation();
  const {
    searchStockQuery,
    setSearchStockQuery,

    searchResults,

    // NEW
    indexResults,
    equityResults,

    searchLoading,

    selectedSearchStock,

    handleSelectSearchStock,

    clearSelectedSearchStock,
  } = useSearchStock();
  const {
    query: globalSearchQuery,
    setQuery: setGlobalSearchQuery,
    results: globalSearchResults,
    loading: globalSearchLoading,
    error: globalSearchError,
    clearResults: clearGlobalSearch,
  } = useGlobalSearch();
  const { market, toggleMarket } = useMarketToggle();
  const { searchStock, error, loading } = useStock();
  const [showNseMenu, setShowNseMenu] = useState(false);
  const [showFeatureMenu, setShowFeatureMenu] = useState(false);
  const { fetchSearchQuery, searchQuery } = useIndicators();

  const dropdownRef = useRef(null);

  const getPlaceholder = () => {
    if (window.matchMedia("(max-width: 300px)").matches) {
      return "Search";
    } else if (window.matchMedia("(max-width: 600px)").matches) {
      return "Search Stocks ";
    }
    return "Search Stocks by Company or Symbol";
  };
  const [placeholder, setPlaceholder] = useState(getPlaceholder());
  useEffect(() => {
    const updateText = () => setPlaceholder(getPlaceholder());
    window.addEventListener("resize", updateText);
    return () => window.removeEventListener("resize", updateText);
  }, []);

  const isNse = market === "india";

  // const handleKeyDown = async (e) => {
  //   if (e.key === "Enter" && search.trim()) {
  //     console.log("Search:", search);
  //     await searchStock(search);
  //     setTimeout(() => setSearch(""), 200);
  //   }
  // };
  // const handleKeyDown = (e) => {
  //   if (e.key === "Escape") {
  //     // setResults([]);
  //     clearSelectedSearchStock();
  //   }
  // };
  const handleKeyDown = (event) => {
    if (event.key !== "Escape") return;

    if (isNse) {
      setSearchStockQuery("");
      clearSelectedSearchStock();
    } else {
      clearGlobalSearch();
    }
  };

  const navigate = useNavigate();
  const nseSymbol = nseCode?.companyProfile?.exchangeCodeNse;
  console.log("nseCode", nseSymbol);
  // const userName = localStorage.getItem("username") || "Admin";
  const userName = user?.userID?.split("@")?.[0];
  console.log("Username", userName);
  const toggleDropdown = () => setIsOpen(!isOpen);

  // };
  // const { logout } = useContext(AuthContext);

  const handleLogout = () => {
    logout(); // ✅ updates instantly
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setShowFeatureMenu(false);
      }
      if (
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target)
      ) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  // useEffect(() => {
  //   const timer = setTimeout(async () => {
  //     if (search.length >= 2) {
  //       const res = await fetch(`${BASE_URL}/api/search-stocks?q=${search}`);
  //       const data = await res.json();
  //       setResults(data);
  //     } else {
  //       setResults([]);
  //     }
  //   }, 300);

  //   return () => clearTimeout(timer);
  // }, [search]);
  //commented for new search

  // useEffect(() => {
  //   if (isNse) {
  //     fetchSearchQuery("");
  //     return;
  //   }

  //   const timer = setTimeout(() => {
  //     if (search.trim().length >= 2) {
  //       fetchSearchQuery(search);
  //     } else {
  //       fetchSearchQuery("");
  //     }
  //   }, 300);

  //   return () => clearTimeout(timer);
  // }, [search, isNse]); //commented for new seatch

  // useEffect(() => {
  //   // ✅ NSE uses DB search context
  //   if (isNse) {
  //     fetchSearchQuery("");

  //     return;
  //   }

  //   // ✅ Global search
  //   const timer = setTimeout(() => {
  //     if (searchStockQuery.trim().length >= 2) {
  //       fetchSearchQuery(searchStockQuery);
  //     } else {
  //       fetchSearchQuery("");
  //     }
  //   }, 300);

  //   return () => clearTimeout(timer);
  // }, [searchStockQuery, isNse]);

  // console.log("results", results);
  console.log("SeatchResults", searchResults);
  console.log("Global search data", searchQuery);
  const searchQueryData = searchQuery?.results;
  console.log("searchQuerydata", searchQueryData);

  const mobileMenuRef = useRef(null);
  const isAdmin = user?.role === "admin";

  // const subMenuItems = [
  //   { item: "One Index", path: "/oneIndex" },
  //   { item: "One Stock", path: "/oneStock" },
  //   { item: "Live News", path: "/news" },
  //   { item: "Live Trend", path: "/dailytrend" },
  //   { item: "EOD Trend", path: "/trendanalysis" },
  //   { item: "HeatMap", path: "/heatmap" },
  //   { item: "Option Chain", path: "/optionchainpage" },
  //   { item: "Max Pain", path: "/maxpain" },
  //   { item: "Most Active Contracts", path: "/activecontracts" },
  // ];
  const subMenuItems = [
    {
      item: "Screeners",
      path: "/screenerpage",
      icon: TbFilterSearch,
    },
    {
      item: "Live Trend",
      path: "/dailytrend",
      icon: TbChartLine,
    },
    {
      item: "Futures",
      path: "/futures",
      icon: TbChartCandle,
    },

    {
      item: "Option Chain",
      path: "/optionchainpage",
      icon: TbBinaryTree2,
    },

    {
      item: "Max Pain",
      path: "/maxpain",
      icon: TbTargetArrow,
    },
    {
      item: "FII DII",
      path: "/fiidii",
      icon: MdAccountBalance,
    },

    {
      item: "Most Active Contracts",
      path: "/activecontracts",
      icon: TbActivityHeartbeat,
    },

    {
      item: "EOD Trend",
      path: "/trendanalysis",
      icon: TbChartHistogram,
    },

    {
      item: "One Index",
      path: "/oneIndex",
      icon: TbWorldSearch,
    },

    {
      item: "One Stock",
      path: "/oneStock",
      icon: TbBuildingBank,
    },

    {
      item: "Live News",
      path: "/news",
      icon: TbNews,
    },
    {
      item: "Test",
      path: "/tradedeal",
      icon: BsGraphUp,
    },
    {
      item: "Test1",
      path: "/tradedeal1",
      icon: BsGraphUp,
    },

    {
      item: "HeatMap",
      path: "/heatmap",
      icon: TbGridDots,
    },
  ];
  const subMenuItemsGlobal = [
    {
      item: "Screeners",
      path: "/marketScreener",
      icon: TbFilterSearch,
    },

    {
      item: "Live News",
      path: "/news",
      icon: TbNews,
    },
  ];

  const navbarItems = [
    {
      item: "Dashboard",
      path: "/dashboard",
      icon: LuLayoutDashboard,
    },

    {
      item: "Watchlist",
      path: "/watchlist",
      icon: FiStar,
    },

    {
      item: "Feedback",
      path: "/feedback",
      icon: FiMessageCircle,
    },

    {
      item: "Help",
      path: "/helper",
      icon: FiHelpCircle,
    },
  ];
  console.log("Selected tab", selectedTab);
  const handleSearchChange = (event) => {
    const value = event.target.value;

    if (isNse) {
      setSearchStockQuery(value);
    } else {
      setGlobalSearchQuery(value);
    }
  };
  return (
    <div>
      <div className="navbar">
        {/* ✅ Logo */}

        <div className="logo">
          <img
            src={qkLogo}
            alt="img"
            className="logo-icon"
            style={{ width: "50px" }}
          />
          <span
            onClick={
              () => navigate("/dashboard")
              // navigate("/testpage")
            }
            style={{ cursor: "pointer" }}
          >
            {/* Phro Trading */}
            Quant Kubera
          </span>
        </div>

        <div className="input-search">
          {/* <input
            type="text"
            placeholder={placeholder}
          
            value={searchStockQuery}
          
            onChange={(e) => setSearchStockQuery(e.target.value)}
            onKeyDown={handleKeyDown}
          /> */}
          <input
            type="text"
            placeholder={
              isNse ? "Search NSE stocks or indices" : "Search global stocks"
            }
            value={isNse ? searchStockQuery : globalSearchQuery}
            onChange={handleSearchChange}
            onKeyDown={handleKeyDown}
          />
          <span>
            <CiSearch />
          </span>

          {isNse &&
            searchStockQuery.trim().length > 0 &&
            (indexResults.length > 0 || equityResults.length > 0) && (
              <div className="search-dropdown">
                {indexResults.length > 0 && (
                  <>
                    <div className="search-section-title">Indices</div>

                    {indexResults.map((item, index) => (
                      <div
                        key={`index-${index}`}
                        className="search-dropdown-item"
                        onClick={() => {
                          navigate(`/indexPage/${item?.displayName}`);

                          setSearchStockQuery("");
                        }}
                      >
                        <div className="dropdown-symbol">
                          {item.underlyingSymbol}
                        </div>

                        <div className="dropdown-company">
                          {item.displayName}
                        </div>
                      </div>
                    ))}
                  </>
                )}

                {equityResults.length > 0 && (
                  <>
                    <div className="search-section-title">Stocks</div>

                    {equityResults.map((item, index) => (
                      <div
                        key={`equity-${index}`}
                        className="search-dropdown-item"
                        onClick={() => {
                          navigate(
                            `/stockdetail/${item?.underlyingSymbol}/${item?.securityId}`,
                          );

                          setSearchStockQuery("");
                        }}
                      >
                        <div className="dropdown-symbol">
                          {item.underlyingSymbol}
                        </div>

                        <div className="dropdown-company">
                          {item.displayName}
                        </div>
                      </div>
                    ))}
                  </>
                )}
              </div>
            )}
          {!isNse && globalSearchResults.length > 0 && (
            <div className="search-dropdown">
              <div className="search-section-title">Global Stocks</div>

              {globalSearchResults.map((item, index) => {
                const symbol = item?.symbol;

                const companyName =
                  item?.longname || item?.shortname || item?.name || symbol;

                const exchange =
                  item?.exchDisp || item?.exchange || item?.typeDisp || "";

                return (
                  <div
                    key={`${symbol || "global"}-${index}`}
                    className="search-dropdown-item"
                    onClick={() => {
                      navigate(`/globalInfo/${encodeURIComponent(symbol)}`);

                      clearGlobalSearch();
                    }}
                  >
                    <div className="dropdown-symbol">{symbol}</div>

                    <div className="dropdown-company">
                      {companyName}

                      {/* {exchange ? exchange : ""} */}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        <div className="desktop-menu">
          <select
            className="select-market-drop"
            value={market}
            onChange={(e) => {
              const selected = e.target.value;
              toggleMarket(selected);

              if (selected === "us") {
                navigate("/dashboard");
              }
              //else {
              //   navigate("/testpage");
              // }
              // toggleMarket(e.target.value)
            }}
            style={{
              borderRadius: "8px",
              border: "none",
              fontWeight: "700",
              // fontWeight: "bold",
              cursor: "pointer",
              background: "inherit",
              color: "#001F3F",
            }}
          >
            <option value="india">NSE</option>
            <option value="us">Global</option>
          </select>
          {/* </li> */}
        </div>

        <ul className="menu desktop-menu">
          {navbarItems.map((item) => {
            const Icon = item.icon;

            return (
              <li key={item.item} className="top-menu-item ">
                <Link to={item.path} className="top-nav-link">
                  <Icon size={18} />

                  <span>{item.item}</span>
                </Link>
              </li>
            );
          })}

          {isAdmin && (
            <li>
              <Link to="/adminpage" className="top-nav-link">
                Admin
              </Link>
            </li>
          )}
        </ul>

        <li
          className="profile-wrapper"
          ref={dropdownRef}
          style={{ cursor: "pointer", listStyle: "none" }}
        >
          <span onClick={toggleDropdown}>
            <CgProfile
              size={28}
              color="rgb(0, 31, 63)"
              style={{ marginRight: "8px", verticalAlign: "middle" }}
            />
          </span>

          {isOpen && (
            <ul className="dropdown-menu">
              <Link
                to={"/userprofile"}
                style={{ textDecoration: "none", color: "white" }}
              >
                <li className="dropdown-item">
                  <span className="dropdown-icon">
                    <CgProfile size={18} />
                  </span>
                  <span style={{ fontWeight: "600", fontSize: "0.9rem" }}>
                    {userName}
                  </span>
                </li>
              </Link>
              <Link
                to={"/watchlist"}
                style={{ textDecoration: "none", color: "white" }}
              >
                <li className="dropdown-item">
                  <span className="dropdown-icon">
                    <HiOutlineSwatch size={18} />
                  </span>
                  <span style={{ fontWeight: "600", fontSize: "0.9rem" }}>
                    My Watchlist
                  </span>
                </li>
              </Link>

              <li
                className="dropdown-item"
                onClick={() => setShowFeatureMenu((prev) => !prev)}
                style={{ position: "relative", cursor: "pointer" }}
              >
                <span
                  style={{ display: "flex", alignItems: "center", gap: "4px" }}
                >
                  Features <LuChevronDown />
                </span>

                {showFeatureMenu && (
                  <ul
                    className="dropdown-hamburger-menu"
                    style={{
                      position: "absolute",
                      top: "30px",
                      left: "0",
                      // background: "#001f3f",
                      borderRadius: "8px",
                      minWidth: "140px",
                      zIndex: 999,
                    }}
                  >
                    <li className="dropdown-sub-item">
                      <Link
                        to="/dailytrend"
                        style={{
                          textDecoration: "none",
                          color: "rgb(0, 31, 63)",
                        }}
                        onClick={() => setShowFeatureMenu(false)}
                      >
                        Daily
                      </Link>
                    </li>

                    <li className="dropdown-sub-item">
                      <Link
                        to="/trendanalysis"
                        style={{
                          textDecoration: "none",
                          color: "rgb(0, 31, 63)",
                        }}
                        onClick={() => setShowFeatureMenu(false)}
                      >
                        Weekly
                      </Link>
                    </li>
                  </ul>
                )}
              </li>
              <li
                className="dropdown-item logout"
                onClick={handleLogout}
                style={{ borderBottom: "none" }}
              >
                <span className="dropdown-icon">
                  <IoLogOutOutline size={18} />
                </span>
                <span>Logout</span>
              </li>
            </ul>
          )}
        </li>
        <div
          className="hamburger-wrapper"
          ref={mobileMenuRef} // for outside click detection
        >
          <FaBars
            className="hamburger-icon"
            size={22}
            color="rgb(0, 31, 63)"
            onClick={() => setMenuOpen((prev) => !prev)}
          />

          {menuOpen && (
            <ul className="dropdown-hamburger-menu mobile-dropdown">
              <li className="dropdown-item">
                <Link
                  to="/dashboard"
                  style={{
                    textDecoration: "none",
                    fontSize: "14px",
                    fontWeight: "bold",
                    // color: "white"
                  }}
                  onClick={() => setMenuOpen(false)}
                >
                  Dashboard
                </Link>
              </li>
              <li className="dropdown-item">
                <Link
                  to="/watchlist"
                  style={{
                    textDecoration: "none",
                    fontSize: "14px",
                    fontWeight: "bold",
                  }}
                  onClick={() => setMenuOpen(false)}
                >
                  Watchlist
                </Link>
              </li>

              <li
                className="dropdown-item"
                onClick={() => {
                  toggleMarket("india");
                  setShowNseMenu((prev) => !prev);
                }}
              >
                <span
                  style={{
                    cursor: "pointer",
                    fontWeight: "bold",
                    display: "flex",
                    gap: "3px",
                  }}
                >
                  NSE <LuChevronDown style={{ alignSelf: "center" }} />
                </span>
              </li>

              {showNseMenu && market === "india" && (
                <>
                  <li className="dropdown-sub-item">
                    <Link
                      // to="/optionchain"
                      to="/optionchainpage"
                      style={{
                        textDecoration: "none",
                        fontSize: "14px",
                        color: "rgb(0, 31, 63)",
                        fontWeight: "700",
                      }}
                      onClick={() => setMenuOpen(false)}
                    >
                      Option Chain
                    </Link>
                  </li>
                  <li className="dropdown-sub-item">
                    <Link
                      // to="/optionchain"
                      to="/maxpain"
                      style={{
                        textDecoration: "none",
                        fontSize: "14px",
                        color: "rgb(0, 31, 63)",
                        fontWeight: "700",
                      }}
                      onClick={() => setMenuOpen(false)}
                    >
                      Max pain
                    </Link>
                  </li>
                  <li className="dropdown-sub-item">
                    <Link
                      to="/trendanalysis"
                      style={{
                        textDecoration: "none",
                        fontSize: "14px",
                        color: "rgb(0, 31, 63)",
                        fontWeight: "700",
                      }}
                      onClick={() => setMenuOpen(false)}
                    >
                      EOD Trend
                    </Link>
                  </li>
                  <li className="dropdown-sub-item">
                    <Link
                      to="/dailytrend"
                      style={{
                        textDecoration: "none",
                        fontSize: "14px",
                        color: "rgb(0, 31, 63)",
                        fontWeight: "700",
                      }}
                      onClick={() => setMenuOpen(false)}
                    >
                      Live Trend
                    </Link>
                  </li>
                  <li className="dropdown-sub-item">
                    <Link
                      to="/activecontracts"
                      style={{
                        textDecoration: "none",
                        fontSize: "14px",
                        color: "rgb(0, 31, 63)",
                        fontWeight: "700",
                      }}
                      onClick={() => setMenuOpen(false)}
                    >
                      Most Active Contracts
                    </Link>
                  </li>
                </>
              )}

              <li
                className="dropdown-item global-item"
                style={{
                  borderTop: showNseMenu ? "1px solid black" : "none",
                }}
                onClick={() => {
                  toggleMarket("us");
                  setMenuOpen(false);
                  navigate("/testpage");
                }}
              >
                <span style={{ cursor: "pointer", fontWeight: "bold" }}>
                  Global
                </span>
              </li>
            </ul>
          )}
        </div>
      </div>

      {/* {isNse && ( */}
      <div className="sub-navbar desktop-menu">
        <ul className="menu desktop-menu">
          {(isNse ? subMenuItems : subMenuItemsGlobal)?.map((item) => {
            const Icon = item.icon;

            return (
              <li
                key={item.item}
                className={`sub-menu-item ${
                  location.pathname === item.path ? "sub-active" : ""
                }`}
              >
                <Link
                  to={item.path}
                  className="sub-nav-link"
                  style={{
                    display: "flex",
                    alignSelf: "center",
                    gap: "5px",
                    textDecoration: "none",
                    color: "#334155",
                  }}
                >
                  <Icon size={18} />

                  <span>{item.item}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
      {/* )} */}
      {/* ── NEW: Mobile sub-navbar wrapped pills ── */}
      {/* {isNse && (
        <div className="sub-navbar-mobile">
          {subMenuItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;

            return (
              <Link
                key={item.item}
                to={item.path}
                className={`sub-nav-pill ${isActive ? "sub-nav-active" : ""}`}
              >
                <Icon size={14} />
                <span>{item.mobileLabel || item.item}</span>
              </Link>
            );
          })}
        </div>
      )} */}
      {isNse && <SubNavbar subMenuItems={subMenuItems} />}

      {error && (
        <p
          style={{
            paddingLeft: "10px",
            color: "black",
            margin: "0",
            fontWeight: "bold",
          }}
        >
          {error}
        </p>
      )}
    </div>
  );
};

export default Navbar;
